import {Component, OnInit} from '@angular/core';
import {Player} from "../../model/player";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {PlayerService} from "../../service/player.service";
import {MatCard, MatCardActions, MatCardContent, MatCardHeader} from "@angular/material/card";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RegistrationService} from "../../service/registration.service";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {EventRegistration, TournamentRegistration} from "../../model/tournamentRegistration";
import {MatOption} from "@angular/material/core";
import {MatIcon} from "@angular/material/icon";
import {MatAnchor, MatButton} from "@angular/material/button";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FullNamePipe} from "../../pipes/fullname-pipe";
import {HeaderService} from "../../service/header.service";
import {MatAutocomplete, MatAutocompleteTrigger} from "@angular/material/autocomplete";
import {MatInput} from "@angular/material/input";

@Component({
  selector: 'app-player-registrations',
  imports: [
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatFormField,
    MatLabel,
    ReactiveFormsModule,
    FormsModule,
    MatCheckbox,
    MatCardActions,
    RouterLink,
    MatOption,
    // MatSelect,
    MatIcon,
    MatButton,
    MatAnchor,
    FullNamePipe,
    MatAutocomplete,
    MatAutocompleteTrigger,
    MatInput,
  ],
  providers: [
    FullNamePipe
  ],
  templateUrl: './player-registrations.component.html',
  standalone: true,
  styleUrl: './player-registrations.component.scss'
})
export class PlayerRegistrationsComponent implements OnInit {

  player: Player;
  tournamentRegistrations: TournamentRegistration[];
  allPlayers: Player[];
  showAll: boolean = false;

  waitingForBackend: boolean = false;

  private partnerSearchTerms: Map<number, string> = new Map();

  constructor(
    private _snackBar: MatSnackBar,
    private playerService: PlayerService,
    private registrationService: RegistrationService,
    private route: ActivatedRoute,
    private router: Router,
    private fullNamePipe: FullNamePipe,
    private headerService: HeaderService,
  ) {}

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    this.playerService.getById(Number(id)).subscribe(data => {
      this.player = data;
      this.headerService.setTitle(`Inschrijvingen van ${this.fullNamePipe.transform(this.player)}`);
    });
    this.registrationService.getTournamentRegistrationsByPlayerId(Number(id)).subscribe(data => {
      this.tournamentRegistrations = data;
    })
    this.playerService.getAll().subscribe(data => {
      this.allPlayers = data;
    });
  }

  onPartnerSearch(searchTerm: any, eventRegistration: EventRegistration) {
    // Only treat as search if it's a string (typed input)
    if (typeof searchTerm === 'string') {
      this.partnerSearchTerms.set(eventRegistration.id, searchTerm?.toLowerCase() || '');
    }
  }

  getFilteredPlayers(eventRegistration: EventRegistration): Player[] {
    const allRelevant = this.getRelevantPlayers(eventRegistration.type);
    const searchTerm = this.partnerSearchTerms.get(eventRegistration.id);

    if (!searchTerm) {
      return allRelevant;
    }

    return allRelevant.filter(player => {
      const fullName = this.fullNamePipe.transform(player).toLowerCase();
      return fullName.includes(searchTerm);
    });
  }

  displayPartnerName(playerId: number | null): string {
    if (!playerId || !this.allPlayers) return '';
    const player = this.allPlayers.find(p => p.id === playerId);
    return player ? this.fullNamePipe.transform(player) : '';
  }

  onPartnerSelected(event: any, eventRegistration: EventRegistration) {
    eventRegistration.partner = event.option.value;
    // Clear the search term when a partner is selected
    this.partnerSearchTerms.delete(eventRegistration.id);
  }


  saveRegistration(tournamentRegistration: TournamentRegistration, event: MouseEvent) {
    this.waitingForBackend = true;
    this.registrationService.saveTournamentRegistrations(tournamentRegistration, this.player.id).subscribe(data => {
      this.waitingForBackend = false;
      this._snackBar.open('Registratie opgeslagen.');
    });
  }

  updateModelWhenEventChecked(eventRegistration: EventRegistration, event: MatCheckboxChange) {
    if (event.checked) {
      eventRegistration.player = this.player.id;
    } else {
      eventRegistration.player = undefined;
    }
  }

  getRelevantPlayers(type: string): Player[] {
    let players: Player[];
    if ( (this.player.sex == 'M' && type == 'HD') ||
         (this.player.sex == 'V' && type == 'GD')
       ) {
      players = this.allPlayers.filter(player => player.sex == 'M' && player.id != this.player.id);
    } else {
      players = this.allPlayers.filter(player => player.sex == 'V' && player.id != this.player.id);
    }

    return players.sort((a, b) =>
      a.lastName < b.lastName ? -1 :
        b.lastName < a.lastName ? 1 :
          a.firstName < b.firstName ? -1 : 1);
  }


  getTournamentRegistrations(): TournamentRegistration[] {
    if (this.showAll) {
      return this.tournamentRegistrations;
    } else {
      return this.tournamentRegistrations.filter(t => t.active);
    }
  }

  protected readonly Player = Player;
  protected readonly EventRegistration = EventRegistration;
}
